import { get, post } from 'utils/api';

export const getLease = async (
  organizationId,
  propertyId,
  leaseId,
  options,
) => {
  const url = `/${organizationId}/${propertyId}/leases/${leaseId}`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getSignaturesStatus = async (
  organizationId,
  propertyId,
  leaseId,
  options,
) => {
  const url = `/${organizationId}/${propertyId}/leases/${leaseId}/signatures/status`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getLeasePdfUrl = async (
  leaseId,
  isRenewal,
  isTransfer,
  options,
) => {
  let url = `/lease/${leaseId}/generate`;
  if (isRenewal === true) {
    url = `/lease/${leaseId}/generateRenewal`;
  }
  if (isTransfer === true) {
    url = `/lease/${leaseId}/generateTransfer`;
  }

  const response = await get(url, { responseType: 'blob', ...options });

  if (response.error) {
    return response.error;
  }

  const pdfUrl = URL.createObjectURL(
    new Blob([response], { type: 'application/pdf' }),
  );

  return pdfUrl;
};

export const postLeaseSignature = async ({
  organizationId,
  propertyId,
  leaseId,
  customerId,
  portalUserId,
  signatureDataUrl,
  initialsDataUrl,
}) => {
  const url = `/${organizationId}/${propertyId}/leases/${leaseId}/signatures`;
  const response = await post(url, {
    leaseId,
    customerId,
    portalUserId,
    signatureDataUrl,
    initialsDataUrl,
  });

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getLeaseMonthlyTransactions = async (args) => {
  const { leaseId } = args;

  const lmtUrl = `/lease/${leaseId}/leaseMonthlyTransactionResident`;
  const data = await get(lmtUrl);

  return data;
};
